/**
 * Route for `igaming-revshare`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingRevsharePage } from "../features/igaming-revshare/IgamingRevsharePage";

export const igamingRevshareRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-revshare",
	component: IgamingRevsharePage,
});

export default igamingRevshareRoute;
